import type { IconType } from 'react-icons/lib';

type PopOutButtonProps = {
  classButton?: string;
  classDiv?: string;
  icon: IconType;
  onClick: () => void;
  openModal: (v: boolean) => void;
  'data-testid'?: string;
};

const buttonClass =
  'transform transition-all relative border-2 opacity-20 text-4xl -left-4 hover:scale-125 hover:text-green-500 hover:translate-x-4 hover:opacity-100';

const divClass = 'fixed left-0 top-80 z-20';

const handleClick = (props: PopOutButtonProps) => {
  const { onClick, openModal } = props;
  onClick();
  openModal(true);
};

export default function PopOutButton(props: PopOutButtonProps) {
  const {
    classButton = buttonClass,
    classDiv = divClass,
    icon: Icon,
    'data-testid': dataTestId,
  } = props;
  return (
    <div className={classDiv}>
      <button
        type='button'
        className={classButton}
        onClick={() => handleClick(props)}
        data-testid={dataTestId}
      >
        <Icon />
      </button>
    </div>
  );
}
